import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize.css/normalize.css' // CSS样式重置的现代替代方案

import '@/permission' // 权限控制文件

import '@/config/elementLazyLoad.js'
import '@/assets/css/element-variables.scss'
import '@/config/echarts.js'
import '@/filters/index.js'

import _ from 'lodash'

// Canvas绘图库
import { fabric } from 'fabric'
Vue.use(fabric)


// 此处是注册多选拖拽功能
import { Sortable, MultiDrag } from 'sortablejs'
Sortable.mount(new MultiDrag())

Vue.config.productionTip = false
Vue.prototype.$tableScrollTop = function () {
  this.$nextTick(() => {
    Array.from(document.querySelectorAll('.el-table__body-wrapper')).forEach((el) => {
      el.scrollTop = 0
    })
  })
}

/**
 * 点击事件添加节流
 */
const on = Vue.prototype.$on
Vue.prototype.$on = function (event, func) {
  if (event === 'click') {
    func = _.debounce(func, 500, { leading: true, trailing: false })
  }
  on.call(this, event, func)
}

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
